import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fa33238"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pro-expiring-modal__text mb-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pro-expiring-modal__text mb-3" }, [
  /*#__PURE__*/_createTextVNode(" После этого: "),
  /*#__PURE__*/_createElementVNode("ul", { class: "pro-expiring-modal__list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "доступ ко всем функциям отключится, ученики сверх лимита будут автоматически перемещены в архив"),
    /*#__PURE__*/_createElementVNode("li", null, "станет доступна новая система тарифов с оплатой отдельных опций")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pro-expiring-modal__text" }, " Вы сможете подключить только нужные функции в любой момент ", -1))

import { ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProExpiringModal',
  props: {
    proExpiresAt: {},
    paymentFailed: { type: Boolean }
  },
  emits: ["hidden", "confirm", "details"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();


function onConfirm() {
    emit('confirm');
    hideModal();
}

function onDetails() {
    emit('details');
    hideModal();
}

const emit = __emit;


function formatDate(dateString: string) {
    const date: Date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return '';
    }

    return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
}

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

__expose({
    show: showModal,
    hide: hideModal,
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffNotificationModal, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "Подписка PRO будет отменена",
    onButtonClick: onConfirm,
    onSecondaryButtonClick: onDetails,
    onHidden: _cache[0] || (_cache[0] = ($event: any) => (emit('hidden'))),
    "button-text": "Оставить PRO",
    "secondary-button-text": "Подробнее",
    "max-width": 450
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, [
        (_ctx.paymentFailed)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" Не удалось списать средства за подписку, вы будете переведены на бесплатный тариф " + _toDisplayString(formatDate(_ctx.proExpiresAt)), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" У вас заканчивается подписка PRO " + _toDisplayString(formatDate(_ctx.proExpiresAt)), 1)
            ], 64))
      ]),
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }, 512))
}
}

})